export const environment = {
  production: false,
  apiBaseUrl: 'https://localhost:7069',
  resetPasswordCode: 'SESSION',
  pageSize: 50,
  notificationsCheckInterval: 30
};